export default __webpack_public_path__ + "static/media/968.d73f818c.JPG";